var exports = {
  "button": "Button.module__button___c2Z6YV",
  "matchSkeletonHeight": "Button.module__matchSkeletonHeight___c2Z6YV",
  "small": "Button.module__small___c2Z6YV",
  "compact": "Button.module__compact___c2Z6YV",
  "superCompact": "Button.module__superCompact___c2Z6YV",
  "fitContent": "Button.module__fitContent___c2Z6YV",
  "fitContainer": "Button.module__fitContainer___c2Z6YV",
  "square": "Button.module__square___c2Z6YV",
  "primary": "Button.module__primary___c2Z6YV",
  "secondary": "Button.module__secondary___c2Z6YV",
  "danger": "Button.module__danger___c2Z6YV",
  "inverted": "Button.module__inverted___c2Z6YV",
  "invertedOutline": "Button.module__invertedOutline___c2Z6YV",
  "ghost": "Button.module__ghost___c2Z6YV",
  "recording": "Button.module__recording___c2Z6YV",
  "buttonRecordingPulse": "Button.module__buttonRecordingPulse___c2Z6YV",
  "spinner": "Button.module__spinner___c2Z6YV",
  "spinnerInner": "Button.module__spinnerInner___c2Z6YV",
  "spinnerItem": "Button.module__spinnerItem___c2Z6YV",
  "spinnerPulsingEllipsis": "Button.module__spinnerPulsingEllipsis___c2Z6YV",
  "iconWrapper": "Button.module__iconWrapper___c2Z6YV",
  "spinnerWrapper": "Button.module__spinnerWrapper___c2Z6YV",
  "hidden": "Button.module__hidden___c2Z6YV",
  "grid": "Button.module__grid___c2Z6YV",
};

__webpack_require__.r(module.exports = exports);
